import { useEffect, useState } from 'react';
import { Box, Button, Group, Paper, Text } from '@mantine/core';
import { registerSW } from 'virtual:pwa-register';

/**
 * Баннер «Доступна новая версия — Обновить».
 *
 * Подписывается на VitePWA registerSW({ onNeedRefresh }) — это срабатывает
 * когда новый service worker встал в waiting (есть свежий deploy, но
 * страница ещё на старом bundle). При клике "Обновить" зовём updateSW(true)
 * — это шлёт SKIP_WAITING в SW, SW активируется, controller меняется,
 * браузер автоматически reload'ит страницу.
 *
 * Если пользователь нажмёт "Не сейчас" — баннер скроется, но новый SW
 * по-прежнему ждёт. При следующем естественном reload активируется сам.
 */
export function PwaUpdateBanner() {
  const [show, setShow] = useState(false);
  const [updateSW, setUpdateSW] = useState<((reload?: boolean) => Promise<void>) | null>(null);

  useEffect(() => {
    const sw = registerSW({
      onNeedRefresh() {
        setShow(true);
      },
      onOfflineReady() {
        // первое полное кэширование — молча.
      },
    });
    setUpdateSW(() => sw);
  }, []);

  if (!show) return null;

  return (
    <Box
      style={{
        position: 'fixed',
        bottom: 16,
        right: 16,
        zIndex: 9999,
        maxWidth: 360,
      }}
    >
      <Paper shadow="md" p="md" withBorder radius="md">
        <Text fz={14} fw={600} mb={4}>Доступна новая версия портала</Text>
        <Text fz={12} c="dimmed" mb="sm">
          Обновите страницу, чтобы получить последние изменения. Несохранённые
          данные на текущей странице могут быть потеряны.
        </Text>
        <Group justify="flex-end" gap="xs">
          <Button size="xs" variant="subtle" onClick={() => setShow(false)}>
            Не сейчас
          </Button>
          <Button size="xs" onClick={() => updateSW?.(true)}>
            Обновить
          </Button>
        </Group>
      </Paper>
    </Box>
  );
}
